import { replaceBehaviour } from '@empathybroker/deep-merge';
import { COMPONENTS, DeepPartial, ResultChildComponentConfig, ResultComponentsConfig, SLOTS } from '@empathybroker/ebx-gluon';

const title: ResultChildComponentConfig = { component: COMPONENTS.PURE.ResultTitle };
const authors: ResultChildComponentConfig = { component: 'CdlResultAuthors' };
const rating: ResultChildComponentConfig = { component: 'CdlResultRating' };
const bindingType: ResultChildComponentConfig = { component: 'CdlResultBindingType' };
const isbn: ResultChildComponentConfig = { component: COMPONENTS.PURE.ResultIdentifier };
const cdlResultTitle: ResultChildComponentConfig = { component: 'CdlResultTitle' };
const cdlResultPrice: ResultChildComponentConfig = { component: 'CdlResultPrice' };
const cdlResultEditions: ResultChildComponentConfig = { component: 'CdlResultEditions' };
const cdlResultOtherOptions: ResultChildComponentConfig = { component: 'CdlResultOtherOptions' };
const cdlResultInfoMessage: ResultChildComponentConfig = { component: 'CdlResultInfoMessage' };
const cdlResultAddToCart: ResultChildComponentConfig = { component: 'CdlResultAddToCart' };
const image: ResultChildComponentConfig = {
  component: COMPONENTS.PURE.ResultImage,
  children: {
    fallbackImage: {
      component: COMPONENTS.PURE.BrokenImageIcon,
      data: { slot: SLOTS.result.fallbackImage }
    }
  }
};

export const MOBILE_DEFAULT_RESULT: DeepPartial<ResultComponentsConfig> = {
  link: {
    children: {
      authors,
      rating,
      bindingType,
      price: cdlResultPrice,
      isLocalData: {
        component: 'CdlResultLocalProduct'
      }
    }
  }
};

export const MOBILE_IDENTIFIER_RESULT: DeepPartial<ResultComponentsConfig> = {
  link: {
    children: replaceBehaviour({
      searchIcon: { component: 'CdlSearchIcon' },
      title,
      isbn,
      arrowIcon: { component: 'CdlArrowIcon' }
    })
  }
};

export const MOBILE_NEXT_QUERY_PARTIALS_RESULT: DeepPartial<ResultComponentsConfig> = {
  link: {
    children: replaceBehaviour({
      image,
      resultInfo: {
        component: 'div',
        data: { staticClass: 'ebx-result-info' },
        children: {
          title,
          authors,
          rating,
          bindingType
        }
      }
    })
  }
};

export const MOBILE_SUGGESTIONS_RESULT: DeepPartial<ResultComponentsConfig> = {
  link: {
    component: COMPONENTS.PURE.ResultLink,
    children: replaceBehaviour({
      image: {
        component: COMPONENTS.PURE.ResultImage,
        children: {
          fallbackImage: {
            component: COMPONENTS.PURE.BrokenImageIcon,
            data: { slot: SLOTS.result.fallbackImage }
          }
        }
      },
      title,
      authors,
      rating
    })
  }
};

export const DESKTOP_DEFAULT_RESULT: DeepPartial<ResultComponentsConfig> = {
  template: {
    component: 'CdlResultTemplate',
    children: replaceBehaviour({
      wrapper: {
        component: 'div',
        data: { staticClass: 'ebx-result-wrapper' },
        children: {
          imageLink: {
            component: COMPONENTS.PURE.ResultLink,
            data: { staticClass: 'ebx-result-image-link' },
            children: { image }
          },
          infoWrapper: {
            component: 'div',
            data: { staticClass: 'ebx-result-info-wrapper' },
            children: {
              isLocalData: {
                component: 'CdlResultLocalProduct'
              },
              resultInfo: {
                component: 'div',
                data: { staticClass: 'ebx-result-info' },
                children: {
                  cdlResultTitle,
                  authors,
                  rating,
                  bindingType,
                  cdlResultPrice,
                  cdlResultEditions,
                  cdlResultOtherOptions,
                  cdlResultInfoMessage,
                  cdlResultAddToCart,
                }
              }
            }
          }
        }
      }
    })
  }
};

export const DESKTOP_IDENTIFIER_RESULT: DeepPartial<ResultComponentsConfig> = {
  template: {
    component: COMPONENTS.PURE.ResultTemplate,
    children: {
      link: {
        component: COMPONENTS.PURE.ResultLink,
        children: { image, title, authors, isbn }
      }
    }
  }
};
